import { useEffect, useRef } from "react";

export const useAutoScroll = (
  conversationLength: number,
  isActivelyStreaming: boolean,
  streamingAIResponse: string,
  showWelcome: boolean
) => {
  const chatWrapperRef = useRef<HTMLDivElement>(null);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const shouldScrollOnNextMessageRef = useRef<boolean>(false);

  // Scroll to bottom function with improved behavior
  const scrollToBottom = () => {
    setTimeout(() => {
      const wrapper = chatWrapperRef.current;
      if (!wrapper) return;
      const targetTop = wrapper.scrollHeight - wrapper.clientHeight;
      wrapper.scrollTo({ top: targetTop, behavior: "smooth" });
    }, 300);
  };

  // Auto-scroll when user sends a new message
  useEffect(() => {
    if (
      shouldScrollOnNextMessageRef.current &&
      conversationLength > 0 &&
      !showWelcome
    ) {
      scrollToBottom();
      shouldScrollOnNextMessageRef.current = false;
    }
  }, [conversationLength, showWelcome]);

  // Auto-scroll when streaming begins
  useEffect(() => {
    if (isActivelyStreaming && conversationLength > 0 && !showWelcome) {
      scrollToBottom();
    }
  }, [isActivelyStreaming, streamingAIResponse, conversationLength, showWelcome]);

  return {
    chatWrapperRef,
    messagesEndRef,
    shouldScrollOnNextMessageRef,
    scrollToBottom,
  };
};
